<template>
  <div class="flex flex-row items-center">
    <span class="mr-[10px]">{{ $i18n('blog.share') }}:</span>
    <client-only>
      <FacebookButton :btn-text="null" :is-blank="false" />
      <TwitterButton :btn-text="null" :is-blank="false" />
      <PinterestButton :btn-text="null" :is-blank="false" />
    </client-only>
  </div>
</template>

<script>
import TwitterButton from 'vue-share-buttons/src/components/TwitterButton.vue';
import PinterestButton from 'vue-share-buttons/src/components/PinterestButton.vue';
import FacebookButton from 'vue-share-buttons/src/components/FacebookButton.vue';

export default {
  name: 'SocialShare',
  components: {
    TwitterButton,
    PinterestButton,
    FacebookButton,
  },
};
</script>

<style lang="scss">
.share-button {
  min-width: auto !important;
  min-height: auto !important;
  width: 30px !important;
  height: 30px !important;
  display: flex !important;
  align-items: center !important;
  text-align: center !important;
  background-color: #000 !important;
  &:hover {
    background-color: #535353 !important;
  }
}
</style>
